import { render, staticRenderFns } from "./batchpub.vue?vue&type=template&id=7f551768&scoped=true"
import script from "./batchpub.vue?vue&type=script&lang=js"
export * from "./batchpub.vue?vue&type=script&lang=js"
import style0 from "./batchpub.vue?vue&type=style&index=0&id=7f551768&scoped=true&lang=css"
import style1 from "./batchpub.vue?vue&type=style&index=1&id=7f551768&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f551768",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f551768')) {
      api.createRecord('7f551768', component.options)
    } else {
      api.reload('7f551768', component.options)
    }
    module.hot.accept("./batchpub.vue?vue&type=template&id=7f551768&scoped=true", function () {
      api.rerender('7f551768', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trade/batchpub.vue"
export default component.exports